export const DEFAULT_COOLING_OFF_PERIOD_DAYS = 7
